export const EMPLOYEEASSESSMENT_LOADING = "EMPLOYEEASSESSMENT_LOADING";
export const EMPLOYEEASSESSMENT_RESET = "EMPLOYEEASSESSMENT_RESET";
export const GET_EMPLOYEEASSESSMENT = "GET_EMPLOYEEASSESSMENT";
export const GET_EMPLOYEEASSESSMENT_SUCCESS = "GET_EMPLOYEEASSESSMENT_SUCCESS";
export const GET_EMPLOYEEASSESSMENT_FAIL = "GET_EMPLOYEEASSESSMENT_FAIL";
export const DELETE_EMPLOYEEASSESSMENT = "DELETE_EMPLOYEEASSESSMENT"
export const DELETE_EMPLOYEEASSESSMENT_SUCCESS = "DELETE_EMPLOYEEASSESSMENT_SUCCESS"
export const DELETE_EMPLOYEEASSESSMENT_FAIL = "DELETE_EMPLOYEEASSESSMENT_FAIL"
export const UPDATE_EMPLOYEEASSESSMENT = "UPDATE_EMPLOYEEASSESSMENT"
export const UPDATE_EMPLOYEEASSESSMENT_SUCCESS = "UPDATE_EMPLOYEEASSESSMENT_SUCCESS"
export const UPDATE_EMPLOYEEASSESSMENT_FAIL = "UPDATE_EMPLOYEEASSESSMENT_FAIL"
export const ADD_NEW_EMPLOYEEASSESSMENT = "ADD_NEW_EMPLOYEEASSESSMENT"
export const ADD_EMPLOYEEASSESSMENT_SUCCESS = "ADD_EMPLOYEEASSESSMENT_SUCCESS"
export const ADD_EMPLOYEEASSESSMENT_FAIL = "ADD_EMPLOYEEASSESSMENT_FAIL"